import React from 'react';
import { motion } from 'framer-motion';

export interface PrincipleItem {
  name: string;
  description: string;
  icon: React.ReactNode;
}

interface PrincipleListProps {
  items: PrincipleItem[];
}

const PrincipleList: React.FC<PrincipleListProps> = ({ items }) => {
  return (
    <dl className="principle-list">
      {items.map((item, index) => (
        <motion.div
          key={item.name}
          className="principle-list__item"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: index * 0.08, duration: 0.45 }}
        >
          <dt>
            <span className="principle-list__icon">{item.icon}</span>
            {item.name}
          </dt>
          <dd>{item.description}</dd>
        </motion.div>
      ))}
    </dl>
  );
};

export default PrincipleList;
